import { AbstractControl } from '@angular/forms';
import { Base, BaseDTO } from './base';

export type DiscountType = 'fixed' | 'percentage';

export interface CouponsFilters {
  search?: string;
}

export interface CouponsDTO extends BaseDTO {
  start_date: string;
  end_date: string;
  name?: string;
  code: string;
  max_uses_per_user: number;
  type: DiscountType;
  discount: number;
  minimum_order_amount: number;
  maximum_order_amount: number;
}

export class Coupons extends Base {
  startDate: Date;
  endDate: Date;
  name?: string;
  code: string;
  maxUsesPerUser: number;
  type: DiscountType;
  discount: number;
  minimumOrderAmount: number;
  maximumOrderAmount: number;

  constructor(source: CouponsDTO) {
    super(source);
    if (source) {
      this.startDate = new Date(source.start_date);
      this.endDate = new Date(source.end_date);
      this.name = source.name;
      this.code = source.code;
      this.maxUsesPerUser = source.max_uses_per_user;
      this.type = source.type;
      this.discount = source.discount;
      this.minimumOrderAmount = source.minimum_order_amount;
      this.maximumOrderAmount = source.maximum_order_amount;
    }
  }

  toDTO(): CouponsDTO {
    return {
      ...super.toDTO(),
      start_date: this.startDate.toISOString().split('T')[0],
      end_date: this.endDate.toISOString().split('T')[0],
      name: this.name,
      code: this.code,
      max_uses_per_user: this.maxUsesPerUser,
      type: this.type,
      discount: this.discount,
      minimum_order_amount: this.minimumOrderAmount,
      maximum_order_amount: this.maximumOrderAmount,
    };
  }

  static fromFormGroup(formGroup: AbstractControl, original?: Coupons) {
    const formModel = formGroup.value;
    let coupon = new Coupons(null);

    coupon.startDate = formModel.startDate ? new Date(formModel.startDate) : null;
    coupon.endDate = formModel.endDate ? new Date(formModel.endDate) : null;
    coupon.name = formModel.name;
    coupon.code = formModel.code;
    coupon.maxUsesPerUser = formModel.maxUsesPerUser;
    coupon.type = formModel.type;
    coupon.discount = formModel.discount;
    coupon.minimumOrderAmount = formModel.minimumOrderAmount;
    coupon.maximumOrderAmount = formModel.maximumOrderAmount;

    if (original) {
      coupon.id = original.id;
    }
    return coupon;
  }
}
